import { render, staticRenderFns } from "./Mountains.vue?vue&type=template&id=78a5264e&scoped=true&"
import script from "./Mountains.vue?vue&type=script&lang=js&"
export * from "./Mountains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5264e",
  null
  
)

export default component.exports